import './cadastro.css';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useAppSelector } from '../../store/hooks';
import { SubmitHandler, useForm } from 'react-hook-form';
import InputLabel from '../../rxlib/components/input-label';
import { obterIdUsuario } from '../../rxlib/services/seguranca';
import TextareaLabel from '../../rxlib/components/textarea-label';
import { HistoricoLicencaOrganizacao } from '../../services/tipos';
import { obterDataAtualJson } from '../../rxlib/services/utilitarios';
import ButtonsCrud from '../../rxlib/components/buttons/buttons-crud';

interface HistoricoLicencaOrganizacaoProps {
    show: boolean;
    onHide: () => void;
    idLicencaOrganizacao: string;
    dadosHistoricoLicencaOrganizacao: {};
    onSubmitForm: (historicoLicencaOrganizacao: HistoricoLicencaOrganizacao) => void;
}

function HistoricoLicencaOrganizacaoView(props: HistoricoLicencaOrganizacaoProps) {
    const [carregando, setCarregando] = useState<boolean>(false);
    const [token] = useState<string>(useAppSelector(state => state.token));

    const [idUsuario] = useState<string>(obterIdUsuario(token));

    const { register, handleSubmit } = useForm<HistoricoLicencaOrganizacao>();

    const onSubmit: SubmitHandler<HistoricoLicencaOrganizacao> = data => {
        setCarregando(true);
        salvar(data);
    }

    function salvar(data: HistoricoLicencaOrganizacao) {
        data.data = obterDataAtualJson(new Date());
        props.onSubmitForm(data);
        props.onHide();
    }

    return (
        <Modal show={props.show} onHide={props.onHide} dialogClassName='naja-modal-historico-licenca-organizacao' centered>
            <Modal.Body className='naja-modal-body-detalhe-historico-licenca-organizacao'>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='container-fluid'>
                        <div className='row px-1'>
                            <div className='col-11'>
                                <h6>Histórico da licença</h6>
                            </div>
                            <div className='col-1 naja-btn-close-cell-detalhe-historico-licenca-organizacao'>
                                <button type='button' className='btn-close' aria-label='Close' onClick={props.onHide} />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1 d-none'>
                                <InputLabel
                                    type='text'
                                    maxLength={50}
                                    readOnly={true}
                                    name='idUsuario'
                                    autoFocus={false}
                                    id='inputIdUsuario'
                                    label='Código usuário:'
                                    defaultValue={idUsuario}
                                    placeholder='Código usuário:'
                                    referencia={register({ required: true })} />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1 d-none'>
                                <InputLabel
                                    type='text'
                                    maxLength={50}
                                    readOnly={true}
                                    required={false}
                                    autoFocus={false}
                                    name='idLicencaOrganizacao'
                                    id='inputIdLicencaOrganizacao'
                                    label='Código da licença da organização:'
                                    defaultValue={props.idLicencaOrganizacao}
                                    referencia={register({ required: false })}
                                    placeholder='Código da licença da organização:' />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <TextareaLabel
                                    defaultValue=''
                                    readOnly={false}
                                    maxLength={2000}
                                    autoFocus={false}
                                    name='observacao'
                                    label='Observação:'
                                    id='inputObservacao'
                                    placeholder='Observação'
                                    className='rxlib-textarea-label-coluna'
                                    referencia={register({ required: true })} />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1 d-none'>
                                <TextareaLabel
                                    name='dados'
                                    label='Dados:'
                                    readOnly={true}
                                    id='inputDados'
                                    maxLength={2000}
                                    autoFocus={false}
                                    placeholder='Dados'
                                    className='rxlib-textarea-label-coluna'
                                    referencia={register({ required: true })}
                                    defaultValue={JSON.stringify(props.dadosHistoricoLicencaOrganizacao)} />
                            </div>
                        </div>
                        <ButtonsCrud
                            visualizar={false}
                            styleButton='btn-rxlib'
                            carregando={carregando}
                            onCancelarVoltar={props.onHide} />
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
}

export default HistoricoLicencaOrganizacaoView;